import { createAsyncThunk } from '@reduxjs/toolkit'

import { toast } from '@buffer-mono/popcorn'

import callRpc from '~publish/legacy/utils/call-rpc'
import { logError } from '~publish/legacy/utils/logError'

export const refreshSingleProfile = createAsyncThunk<
  unknown,
  { profileId: string; message?: string }
>(
  'profiles/refreshSingleProfile',
  async ({ profileId, message }, { rejectWithValue }) => {
    try {
      const response = await callRpc('singleProfile', {
        profileId,
      })

      if (!response) {
        throw new Error('No profile was returned.')
      }

      if (message) {
        toast.success(message)
      }

      return response
    } catch (error) {
      logError(error)

      return rejectWithValue(null)
    }
  },
)
